import type { GetItem } from "@mnk/shared/models/item";
import ArticleIcon from "@mui/icons-material/Article";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FolderIcon from "@mui/icons-material/Folder";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChangeNameModal } from "./ChangeNameModal";
import { NoItems } from "./NoItems";
interface Props {
  items: GetItem[];
  setIsNewFolderModalOpen: (isOpen: boolean) => void;
  setIsNewProjectModalOpen: (isOpen: boolean) => void;
  mutateItems: () => Promise<void>;
}

export const ItemCardView = ({ items, setIsNewFolderModalOpen, setIsNewProjectModalOpen, mutateItems }: Props) => {
  const [selectedItem, setSelectedItem] = useState<GetItem | null>(null);
  const [isChangeNameModalOpen, setIsChangeNameModalOpen] = useState(false);
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <NoItems setIsNewFolderModalOpen={setIsNewFolderModalOpen} setIsNewProjectModalOpen={setIsNewProjectModalOpen} />
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((item) => {
          const link = item.itemType === "folder" ? `/folders/${item.id}` : `/projects/${item.id}`;
          return (
            <div
              key={item.id}
              className="bg-white rounded-lg p-4 cursor-pointer"
              onClick={() => {
                navigate(link);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  navigate(link);
                }
              }}
            >
              <h2 className="text-lg flex items-center gap-2 pb-2">
                {item.itemType === "folder" ? <FolderIcon className="w-3 h-3" /> : <ArticleIcon className="w-3 h-3" />}
                {item.name}
              </h2>
              <div className="flex items-center justify-between gap-2 border-t border-gray-200 pt-2">
                <div className="flex items-center justify-center gap-2">
                  <button
                    type="button"
                    className="text-gray-500 hover:text-gray-700 cursor-pointer flex items-center gap-1 text-sm"
                    onClick={() => {
                      setSelectedItem(item);
                      setIsChangeNameModalOpen(true);
                    }}
                  >
                    <EditIcon className="w-3 h2-3" />
                    名称変更
                  </button>
                </div>
                <div className="flex items-center justify-center gap-2">
                  <button
                    type="button"
                    className="text-gray-500 hover:text-gray-700 cursor-pointer flex items-center gap-1 text-sm"
                  >
                    <DeleteIcon className="w-2 h-2" />
                    削除
                  </button>
                </div>
              </div>
            </div>
          );
        })}
        {selectedItem && (
          <ChangeNameModal
            isOpen={isChangeNameModalOpen}
            onClose={() => setIsChangeNameModalOpen(false)}
            item={selectedItem}
            mutateItems={mutateItems}
          />
        )}
      </div>
    </>
  );
};
